import AbeApi from './abe';
import testApi from './template_example';
import authApi from './authentication';
import serviceApi from './service';
import taskApi from './tasks';
import categoryApi from './category';
import skillApi from './skill';
import ConfigApi from './configuration';
import UserInvitationApi from './resources/invitations';
import CompanyInvitationApi from './companies/invitations';
import MaterialApi from './materials';
import CompanyApi from './company';
import MeasureApi from './measure';
import ClientApi from './client';
import ClientPageApi from './clientPage';
import MapsApi from './mapApi';
import leadsApi from './lead';
import StorageApi from './storage';
import SearchApi from './search';
import UserResocesApi from './resources/user';
import UserRequestsApi from './resources/requests';
// import AvailabilityApi from './resources/availability';
import LeadServiceTimesApi from './lead/leadServicesTime';
import ProposalApi from './proposal';
import CalendarApi from './calendar';
import ProjectApi from './projects';
import DashboardApi from './dashboard';
import TravelTimeIterationApi from './travelTimeIteration';
import InvoicesApi from './invoices';
import TimesheetApi from './timesheet';
import AssignmentsApi from './assignments';
import IntegrationsApi from './integration';
import ImpersonateApi from './impersonate';
import LocationHistoryApi from './locationHistory';
import ProposalMessagesTemplateApi from './proposalMessagesTemplate';
import Widgets from './catalog/widgets';
import AdvancedDashboardApi from './advancedDashboard';
import userInsights from './resources/insights';
import checklistApi from './checklist';
import NotesApi from './notes';
import NotificationFeed from './notificationFeed';
import TermsAndConditionsApi from './termsAndConditions';
import PauseIterationApi from './pauseIteration';
import MarginDashboardApi from './marginDashboard';
import PartnerApi from './partner';
import ServiceRequestApi from './serviceRequest';
import * as InspectionsApi from './inspections';
import MarginLadderApi from './marginLadder';
import RecalibrationApi from './recalibration';
import RfpParserApi from './rfpParser';
import ServiceCatalogApi from './serviceCatalog';
import SubAnalysisApi from './subAnalysis';
import WorkloadingApi from './workloading';

export default {
  AbeApi,
  AdvancedDashboardApi,
  AssignmentsApi,
  CalendarApi,
  // AvailabilityApi,
  ClientApi,
  ClientPageApi,
  CompanyApi,
  CompanyInvitationApi,
  ConfigApi,
  DashboardApi,
  ImpersonateApi,
  IntegrationsApi,
  InvoicesApi,
  LeadServiceTimesApi,
  LocationHistoryApi,
  MapsApi,
  MarginDashboardApi,
  MarginLadderApi,
  MaterialApi,
  MeasureApi,
  NotesApi,
  NotificationFeed,
  PartnerApi,
  ServiceRequestApi,
  InspectionsApi,
  PauseIterationApi,
  ProjectApi,
  ProposalApi,
  ProposalMessagesTemplateApi,
  RecalibrationApi,
  RfpParserApi,
  SearchApi,
  ServiceCatalogApi,
  StorageApi,
  SubAnalysisApi,
  TermsAndConditionsApi,
  TimesheetApi,
  TravelTimeIterationApi,
  UserInvitationApi,
  UserRequestsApi,
  UserResocesApi,
  Widgets,
  WorkloadingApi,
  authApi,
  categoryApi,
  checklistApi,
  leadsApi,
  serviceApi,
  skillApi,
  taskApi,
  testApi,
  userInsights
};
